import React, { useState } from "react";
import {
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { ArrowDownLeftIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import { UserPlusIcon, ArrowDownTrayIcon } from "@heroicons/react/24/solid";
import {
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  Chip,
  Avatar,
  Tooltip,
} from "@material-tailwind/react";
import axios from "axios";
import swal from "sweetalert";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL } from '../../../data/static-config.js';
import { setLoaderVisibility } from "../../../app/actions/action-creators.js";

export function TableProposalList({ keyDown, REFRESH_TABLE }) {
  const [showModal, setShowModal] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [id, setId] = useState();
  const token = useSelector((state) => state?.combineReducer?.adminToken?.token);
  const languageCode = useSelector((state) => state?.combineReducer?.clientLanguage?.data);
  const headers = useSelector((state) => state?.combineReducer?.adminOrganizations?.proposals?.data?.proposalListHeader);
  const data = useSelector((state) => state?.combineReducer?.adminOrganizations?.proposals?.data?.proposalList);
  const dispatch = useDispatch();

  const search = (event) => {
    setSearchKey(event.target.value);
  }

  const handleKeyDown = () => {
    keyDown(searchKey);
  };

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      dangerMode: true,
      buttons: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          dispatch(setLoaderVisibility(true));
          axios.delete(`${API_BASE_URL}/api/proposal/${id}`, {
            headers: {
              access_token: token
            }
          }).then((_) => {
            REFRESH_TABLE();
            dispatch(setLoaderVisibility(false));
          }).catch((err) => {
            console.log(err)
            dispatch(setLoaderVisibility(false));
          })
        }
      });
  };

  return (
    <>
      <CardHeader floated={false} shadow={false} className="rounded-none">
        <div className="flex flex-col items-center justify-between md:flex-row">
        <div className="relative flex w-full gap-2 md:w-max"></div>
          <div className="relative flex w-full gap-2 mt-4 md:w-max">
            <div className="w-full md:w-72">
              <Input
                label="Search"
                icon={<MagnifyingGlassIcon className="h-5 w-5" />} value={searchKey}
                onChange={(e) => search(e)}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className="overflow-scroll px-2">
        <table className="w-full min-w-max table-auto text-left">
          <thead>
            <tr>
              {headers?.map((head, index) => (
                <th
                  key={head}
                  className="cursor-pointer border-y border-gray-400 bg-blue-gray-50/50 p-4"
                >
                  <Typography
                    variant="small"
                    color="gray"
                    className="flex items-center justify-between gap-2 font-normal leading-none"
                  >
                    {head}
                  </Typography>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map(
              ({ id, orgName, orgEmail, programName, programId, fileUrl }, index) => {
                const isLast = index === data?.length - 1;
                const classes = isLast
                  ? "p-4"
                  : "p-4 border-b border-blue-gray-50";

                return (
                  <tr key={id}>
                    <td className={classes} style={{ maxWidth: "400px" }}>
                      <div className="flex items-center gap-3">
                        <Tooltip content={languageCode == 1033 ? "Download Attachment" : "Unduh Lampiran"}>
                          <Typography as="a" target="_blank" href={fileUrl} className="w-8 opacity-80 transition-opacity hover:opacity-100">
                            <ArrowDownTrayIcon className="text-ifmpallet2" color="white" />
                          </Typography>
                        </Tooltip>
                      </div>
                    </td>
                    <td className={classes} style={{ maxWidth: "400px" }}>
                      <div className="flex items-center gap-3">
                        <div className="flex flex-col">
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal"
                          >
                            {orgName}
                          </Typography>
                        </div>
                      </div>
                    </td>
                    <td className={classes} style={{ maxWidth: "200px" }}>
                      <div className="flex flex-col">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {orgEmail}
                        </Typography>
                      </div>
                    </td>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        {programName}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Button color="red" variant="gradient" size="sm" className="flex items-center gap-2 m-1" onClick={() => handleDelete(id)}>
                        <TrashIcon className="w-4" />
                        Delete
                      </Button>
                    </td>
                  </tr>
                );
              },
            )}
          </tbody>
        </table>
      </CardBody>
    </>
  );
}